import React from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import ErrorBoundary from '@/components/ErrorBoundary'
import { ValidationBoundary, ValidationState } from '@/components/validation'
import OrganizationalUnitForm from '@/internal-app/pages/organizationalUnits/form'

class OrganizationalUnitDialog extends React.Component {
  state = {
    unit: this.props.value || {
      parent: this.props.parent,
      organizationUnitParentId: this.props.parent ? this.props.parent.organizationUnitId : null
    }
  }

  handleConfirm = () => {
    if (!this.state.unit) {
      return false
    }
    this.props.onAction(this.state.unit)
  }

  render () {
    const { parent, availableParents, units, ...props } = this.props
    return (
      <ValidationBoundary>
        <BasicHeader title='OrganizationalUnit.CreateNew' {...props} />
        <ModalBody>
          <ErrorBoundary>
            <OrganizationalUnitForm
              unit={this.state.unit} parent={parent} availableParents={availableParents} units={units}
              onChange={value => this.setState({ unit: { ...this.state.unit, ...value } })} />
          </ErrorBoundary>
        </ModalBody>
        <ValidationState render={({ isValid }) =>
          <ConfirmFooter {...props} onAction={this.handleConfirm} disabled={!isValid} />
        } />
      </ValidationBoundary>
    )
  }
}

export default {
  component: OrganizationalUnitDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/organizationalUnit.js